import {injectable} from "inversify";
import {Terrace} from "@/modules/stadium/entity";
import {TerraceTypeEnum} from "@/modules/stadium/enums";

@injectable()
export default class TerraceFactory {
  public async generate(data: { type: TerraceTypeEnum, seats: number, limit?: number | null, available: boolean, entranceFee: number }) {
    const terrace = new Terrace();
    terrace.type = data.type;
    terrace.seats = data.seats;
    terrace.seatsLimit = data.limit ?? 0;
    terrace.available = data.available;
    terrace.entranceFee = data.entranceFee;
    await terrace.save();

    return terrace;
  }
}
